module.exports = __webpack_public_path__ + "img/cardlogo.da2580e7.png";